import React, { useEffect } from 'react';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';

import { isEmpty, isNumber } from 'lodash';

import { Select, Input, Autocomplete } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';

import { Container } from './styles';
import * as S from './styles';

export default function DadosPostoPlanejamento({ data, formRef }) {
  const [valueOrgao, setValueOrgao] = React.useState('');
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState('');
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  useEffect(() => {
    if (!isEmpty(data)) {
      setValueOrgao(data.posto.orga_codigo);
      setValueUnidade(data.posto.unid_codigo);
    }
  }, [data]);

  useEffect(() => {
    setValueUnidade('');
    setInputValueUnidade('');
  }, [valueOrgao])

  useEffect(() => {
    if (!isEmpty(data) && !isEmpty(data.posto)) {
      if (
        isNumber(valueOrgao) &&
        valueOrgao !== 0 &&
        valueOrgao !== data.posto.orga_codigo
      ) {
        formRef.current.setFieldValue('unid_codigo', '');
      }
    }
  }, [data, valueOrgao]);

  return (
    <>
      <S.ConteinerTab>
        <ExpansionPanel expanded>
          <ExpansionPanelSummary
            aria-controls="panel1a-content"
            id="panel1a-header"
            style={{
              background: 'rgba(0, 0, 0, 0.05)',
              borderBottom: '1px solid rgba(0,0,0,.2)',
            }}
          >
            <Typography>Posto</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Container>
              <Input
                name="poco_codigo"
                label="Código"
                style={{ marginTop: '20px' }}
                disabled={true}
              />

              <Input name="poco_descricao" label="Descrição" disabled={true} />

              <Input
                name="poco_desc_abrev"
                label="Descrição Abreviada"
                disabled={true}
              />

              <Input name="poco_nome_fantasia" label="Nome Fantasia" />

              <Autocomplete
                name="orga_codigo"
                label="orga_nome"
                title="Órgão"
                id="orga_codigo"
                url="orgaos"
                unique="orga_codigo"
                value={valueOrgao}
                inputValue={inputValueOrgao}
                onChange={(event, newValue) => {
                  setValueOrgao(newValue);
                }}
                onInputChange={(event, newInputValueOrgao) => {

                  setInputValueOrgao(newInputValueOrgao);
                }}
                defaultValue=""
                hiddens={[{ name: 'orga_nome' }]}
                getValue={(value) => {
                  if (value.orga_codigo !== null) {
                    setValueOrgao(value.orga_codigo);
                  } else {
                    setValueOrgao('');
                  }
                }}
              />

              <SelectComplete
                name="unid_codigo"
                label="unid_nome"
                title="Unidade"
                id="unid_codigo"
                url="unidades"
                unique="unid_codigo"
                value={valueUnidade}
                inputValue={inputValueUnidade}
                onInputChange={(event, newInputValueUnidade) => {
                  setInputValueUnidade(newInputValueUnidade);
                }}
                hiddens={[{ name: 'unid_nome' }]}
                getValue={(value) => {
                  if (value.unid_codigo !== null) {
                    setValueUnidade(value.unid_codigo);
                  } else {
                    setValueUnidade('');
                  }
                }}
                params={{
                  wherefield: 'orga_codigo',
                  valuewherefield: valueOrgao,
                  typewherefield: 'EQUALS',
                }}
              />

              <Input name="poco_endereco" label="Endereço" />

              <Input name="poco_cep" label="CEP" />

              <Autocomplete
                name="muni_codigo"
                label="muni_nome"
                title="Município"
                id="muni_codigo"
                url="municipio"
                unique="muni_codigo"
                defaultValue=""
                hiddens={[{ name: 'muni_nome' }]}
              />

              <Input name="poco_telefone" label="Telefone" />

              <Select
                name="poco_status"
                variant="outlined"
                label="Status"
                disabled={true}
                options={[
                  { label: 'Liberado', value: '1' },
                  { label: 'Bloqueado', value: '2' },
                  { label: 'Cancelado', value: '3' },
                ]}
              />
            </Container>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </S.ConteinerTab>
    </>
  );
}
